import { api_without_cancellation } from "./api";

const caseUrl = (clientId, caseId) => `/api/cocounsel/${clientId}/${caseId}/`;

export const listCoCounsel = async (clientId, caseId) =>
  (await api_without_cancellation.get(caseUrl(clientId, caseId))).data.data;
export const createCoCounsel = async (clientId, caseId, payload) =>
  (await api_without_cancellation.post(caseUrl(clientId, caseId), payload)).data;
export const sendCoCounselInvite = async (cocounselId, timezone, email = "") =>
  (
    await api_without_cancellation.post(`/api/cocounsel/${cocounselId}/send-invite/`, {
      timezone,
      ...(email.trim() ? { email: email.trim() } : {}),
    })
  ).data;
// favorites=true returns only this firm's starred firms; query is optional in that mode
export const searchCoCounselFirms = async ({ query = "", favorites = false } = {}) =>
  (
    await api_without_cancellation.get("/api/SearchAttorney/", {
      params: { ...(query ? { query } : {}), ...(favorites ? { favorites: true } : {}) },
    })
  ).data.data;
// directoryId is the SearchAttorney row id; idempotent, so repeat calls are safe
export const setCoCounselFavorite = async (directoryId, favorite) =>
  (
    await api_without_cancellation.post("/api/cocounsel/favorite-firms/", {
      directory_id: directoryId,
      favorite,
    })
  ).data;
// positions: {"1": staff_id | null, ...}; partial slots allowed
export const updateCoCounselPositions = async (cocounselId, positions) =>
  (
    await api_without_cancellation.patch(`/api/cocounsel/${cocounselId}/positions/`, {
      positions,
    })
  ).data;
